import React, { useEffect, useRef, useState } from "react";
import Select from "../element/Select";

export const Pagination = ({
  totalCount,
  pageNumber,
  displayPage,
  UpdatePageLimit,
  UpdatePage,
  allfilters,
  limit,
}) => {

  const [countOptions, setCountOptions] = useState([
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
  ]);
    
  const initialLimit = limit || (allfilters?.limit ? Number(allfilters?.limit) : 10);
  const [itemsPerPage, setItemsPerPage] = useState([{ label: initialLimit, value: initialLimit }]);
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const lastAppliedLimitRef = useRef(itemsPerPage?.[0]?.value);

  // Sync itemsPerPage if limit prop or allfilters.limit changes from outside
  useEffect(() => {
    const propLimit = limit || (allfilters?.limit ? Number(allfilters?.limit) : undefined);
    if (propLimit && itemsPerPage?.[0]?.value !== propLimit) {
      setItemsPerPage([{ label: propLimit, value: propLimit }]);
      lastAppliedLimitRef.current = propLimit;
    }
  }, [limit, allfilters?.limit]);

  const currentLimit = itemsPerPage?.[0]?.value || 10;
  const pNum = Math.max(Number(pageNumber) || 1, 1);
  const fromRecord = totalCount === 0 ? 0 : (pNum - 1) * currentLimit + 1;
  const pageItems = typeof displayPage === "number" && displayPage > 0 ? displayPage : currentLimit;
  const toRecord = totalCount === 0 ? 0 : Math.max(fromRecord, Math.min((pNum - 1) * currentLimit + pageItems, totalCount));

  // Update current pageNumber
  useEffect(() => {
    const desiredLimit = itemsPerPage[0].value;

    if (lastAppliedLimitRef.current === desiredLimit) {
      return;
    }

    lastAppliedLimitRef.current = desiredLimit;
    if (allfilters) {
      const currentLimit = Number(allfilters?.limit) || allfilters?.limit;

      if (currentLimit === desiredLimit) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      const updatePromise = UpdatePageLimit({
        ...allfilters,
        limit: desiredLimit,
        page: 1,
      });

      if (updatePromise && updatePromise.finally) {
        updatePromise.finally(() => setIsLoading(false));
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(true);
      const limitUpdatePromise = UpdatePageLimit(desiredLimit);
      const pageUpdatePromise = UpdatePage(1);

      if (
        limitUpdatePromise &&
        limitUpdatePromise.finally &&
        pageUpdatePromise &&
        pageUpdatePromise.finally
      ) {
        Promise.all([limitUpdatePromise, pageUpdatePromise]).finally(() =>
          setIsLoading(false)
        );
      } else {
        setIsLoading(false);
      }
    }
  }, [itemsPerPage, allfilters]);
  return (
    <>
      {isLoading && <div>Loading...</div>} {/* Show loading indicator */}
      {!isLoading && totalCount === 0 && (
        <div className="h-full w-full text-center mt-2">No data available</div>
      )}
      {/* Show "No Data Available" when totalCount is 0 */}
      {!isLoading && totalCount > 0 && (
        <div className="flex choose-show-fields mt-4 gap-2 items-center">
          <Select
            value={itemsPerPage}
            onChange={(e) =>
              setItemsPerPage([{ label: e.label, value: e.value }])
            }
            options={countOptions}
          />
          Displaying {fromRecord}-{toRecord} of <span>{totalCount}</span> records
        </div>
      )}
    </>
  );
};
